import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

export const getStatsSubscriptions = gql`
  subscription {
    serverStatsSub{
      jsonObject
    }
  }
`;

export const getPinSubscriptions = gql`
  subscription pinStatsSub($pid: Int, 
                $date: Int){
    pinStatsSub(pid: $pid, date: $date) {
      jsonObject
    }
  }
`;

export const gq_pinStats = gql`
  mutation pinStats($pid: Int, 
                $dateFilter: Int) {
    pinStats(pid: $pid, dateFilter: $dateFilter) {
      jsonObject
    }
  }
`

export const gq_projects = gql`
  query {
    allProjects {
      edges {
        node {
          pid
          name
        }
      }
    }
  }
`

export const gq_serverStats = gql`
  mutation serverStats {
    serverStats {
      jsonObject
    }
  }
`

export const getStatsSubscriptions2 = gql`
  subscription callCheckSub($pin: Int, $pid: Int){
    callCheckSub(pid: $pid, pin: $pin){
      jsonObject
    }
  }
`;

export const getPinStatsQuery = compose(
  graphql(gq_pinStats,{
    name: "getPinStatsQuery",
    options: {
        errorPolicy: "all",
        fetchPolicy: 'cache-and-network'
      },
  }),
  graphql(gq_serverStats,{
    name: "getServerStats",
    options: {
      errorPolicy: "all",
      fetchPolicy: "network-only"
    }
  })
);




// WEBPACK FOOTER //
// ./src/views/stats/graph.js